import React from 'react';
import PropTypes from 'prop-types';
import { SvgArrow } from '../../svg';
import { perCentToString } from '../../utils';
import { LabelTrendContainer } from './styles';

function LabelTrend({ value }) {
  const trend = Math.sign(value) === -1 ? 'bottom' : 'top';
  const label = perCentToString(Math.abs(value));

  return (
    <LabelTrendContainer trend={trend}>
      <SvgArrow direction={trend} />
      <label htmlFor="trend">{label}</label>
    </LabelTrendContainer>
  );
}

LabelTrend.propTypes = {
  value: PropTypes.number,
};

export default LabelTrend;
